export default "__VITE_ASSET__3e3cdf47__"